import { render, staticRenderFns } from "./OeamtcIcon.vue?vue&type=template&id=58dd58c2&scoped=true&"
import script from "./OeamtcIcon.vue?vue&type=script&lang=ts&"
export * from "./OeamtcIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd58c2",
  null
  
)

export default component.exports